import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { Criteria } from '../../../shared/interfaces/qualification.interface';
import { BuyerApiService } from '../../../shared/services/buyer-api/survey.service';
import { QuotaService } from '../../../shared/services/quota/quota.service';
import { ToasterService } from '@purespectrum1/ui/toaster-service';

@Component({
  selector: 'ps-ui-rename-quota-modal',
  templateUrl: './rename-quota-modal.component.html',
  styleUrls: ['./rename-quota-modal.component.css'],
})
export class RenameQuotaModalComponent implements OnInit {
  public renamedQuota = '';
  constructor(
    @Inject(ModalData)
    private _modalData: {
      ps_quota_id: string;
      survey_id: number;
      quota_name: string;
      quota_key: string;
      quota_index: number;
      quota_criteria: Criteria[];
    },
    private _toastr: ToasterService,
    private _modalRef: ModalRef<RenameQuotaModalComponent, string>,
    private _buyerApiService: BuyerApiService,
    private _quotaService: QuotaService
  ) {}

  ngOnInit(): void {
    this.renamedQuota = this._modalData.quota_name;
  }
  public close() {
    this._modalRef.close(JSON.stringify({ msg: 'close' }));
  }

  public renameQuota() {
    this._buyerApiService
      .updateQuotaData(this._modalData.survey_id, this._modalData.ps_quota_id, [
        { op: 'replace', path: '/quota_title', value: this.renamedQuota },
      ])
      .subscribe(
        (resp) => {
          if (!this.renamedQuota) {
            this.renamedQuota =
              this._quotaService.breakArrayAndJoinQuotaViewItem(
                this._modalData.quota_criteria
              );
          }
          this._modalRef.close(
            JSON.stringify({ msg: 'success', newQuotaName: this.renamedQuota })
          );
        },
        (error) => {
          this._toastr.error(error.error.ps_api_response_message);
        }
      );
  }

  public validateAlphaNumeric(e: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9, -]+$/;
    if (regex.test(e.key)) {
      return true;
    }
    e.preventDefault();
    return false;
  }
}
